<!-- 政策库-->
<template>
  <div>
    <div class="sub_wrapper">
      <div class="banner_wrap">
        <div class="b_cont step_box">
          <div class="step_cel step1" :class="{ active: chooseQy == 'chooseQy' }">
            <div class="icon"></div>
            <div class="txt" style="width: 96px;"><span>①</span><i>选择企业</i></div>
          </div>
          <div class="step_cel step2" :class="{ active: perfectInfo == 'perfectInfo' }">
            <div class="icon"></div>
            <div class="txt" style="width: 96px;"><span>②</span><i>完善信息</i></div>
          </div>
          <div class="step_cel step3" :class="{ active: report == 'report' }">
            <div class="icon"></div>
            <div class="txt" style="width: 132px;"><span>③</span><i>智能推荐报告</i></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
    // FilterCheckBoxThree,
  },
  props:{
    chooseQy: {
      type: String,
      required: true
    },
    perfectInfo: {
      type: String,
      required: true
    },
    report: {
      type: String,
      required: true
    },
  },
  data() {
    return {

      hydlList2: 1,
    };
  },

  methods: {

  },

  created() {

  },
  mounted() {
  },
  destroy() {
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/newStyle/css/idx.scss";

</style>
